module.exports = "/images/model_11a898.png";